import React from 'react';
import logo from './placeholder.svg';
import './App.css';

const App = () => {
  return (
    <div className="home-container">
      <header className="home-body">
        <img src={logo} className="home-logo" alt="logo" />
        <p>
          Lucy is building her website and will have something nice for you soon
        </p>
      </header>
    </div>
  );
}

export default App;
